import { ComponentRef, Directive, ElementRef, HostBinding, HostListener, Input, ViewContainerRef } from '@angular/core';
import { DropdownMenuComponent, GroupedMenuItems, MenuItem } from '../components/dropdown-menu/dropdown-menu.component';

@Directive({
    selector: '[appDropdown]',
    standalone: true,
})
export class DropdownDirective {

    private active = false;
    private menuComponentRef: ComponentRef<DropdownMenuComponent> = null;

    // ----------[ Input ]----------

    @Input()
    appDropdown: MenuItem[] | GroupedMenuItems[] = [];

    @Input()
    appDropdownAlign: 'left' | 'right' = 'left';

    constructor(
        private elementRef: ElementRef,
        private viewContainerRef: ViewContainerRef,
    ) {
    }

    // ----------[ Bindings ]----------

    @HostBinding('class')
    get class(): string {
        return this.active ? 'relative' : 'relative cursor-pointer';
    }

    // ----------[ Event Handlers ]----------

    @HostListener('click')
    onClick() {
        if (!this.active) {
            this.open();
        } else {
            this.close();
        }
    }

    @HostListener('document:click', ['$event'])
    onClickDocument(event: MouseEvent) {
        if (!this.active) return;
        if (!this.viewContainerRef.element.nativeElement.contains(event.target)) {
            this.close();
        }
    }

    // ----------[ Methods ]----------

    private open() {
        this.createMenuComponent();
        this.active = true;
    }

    private close() {
        this.destroyMenuComponent();
        this.active = false;
    }

    private createMenuComponent() {
        const componentRef = this.viewContainerRef.createComponent(DropdownMenuComponent);
        componentRef.instance.items = this.appDropdown;
        componentRef.instance.align = this.appDropdownAlign;
        componentRef.instance.active = true;

        this.elementRef.nativeElement.appendChild(componentRef.location.nativeElement);

        this.menuComponentRef = componentRef;
    }

    private destroyMenuComponent() {
        const ref = this.menuComponentRef;
        ref.instance.active = false;
        setTimeout(() => ref.destroy(), 250);

        this.menuComponentRef = null;
    }

}
